import { Component, HostListener, OnInit } from '@angular/core';
import { KingClubAssets } from '../../shared/enum/icons';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { AccountSwitchDialogComponent } from '../account-switch-dialog/account-switch-dialog.component';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  animations:[
    trigger('expandCollapse', [
      state(
        'void',
        style({
          height: '0px',
          overflow: 'hidden',
          opacity: 0
        })
      ),
      state('collapsed', style({ height: '0', overflow: 'hidden', opacity:0})),
      state('expanded', style({ height: '*', overflow: 'hidden', opacity: 1 })),
      transition('collapsed <=> expanded', animate('200ms ease-out'))
    ]),

    trigger('slideInLeft', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('600ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ])
    ]),

   
    trigger('slideInRight', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('600ms ease-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ])
    ]),

    
    trigger('emergeFromBehind', [
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-30%)' 
        }),
        animate('600ms 400ms ease-out', 
          style({
            opacity: 1,
            transform: 'translateX(0)'
          })
        )
      ])
    ])
  ]
})
export class LandingPageComponent implements OnInit {
  screenWidth: number = window.innerWidth;
  isMobileView = this.screenWidth <= 960;
  kingAseets = KingClubAssets;
  socialMediaLinks = [
    {
      link:'',
      icon: this.kingAseets.InstagramLogo,
      alt: 'King Instagram link'
    },
    {
      link:'',
      icon: this.kingAseets.TelegramLogo,
      alt: 'Telegram Instagram link'
    },
    {
      link:'',
      icon: this.kingAseets.LinkedinLogo,
      alt: 'Linkedin Instagram link'
    },
    {
      link:'',
      icon: this.kingAseets.XLogo,
      alt: 'X Instagram link'
    },
    {
      link:'',
      icon: this.kingAseets.FacebookLogo,
      alt: 'Facebook Instagram link'
    },
  ]

  summaryItems = ['Earn Rewards', 'Flexible Rewards', 'Extra Discounts', 'Exclusive Deals'];
  
  whyKingClubItems = [
    {
      title: 'Save Money',
      description: `Every time you shop, you earn discounts that add up quickly. Whether you’re buying groceries, updating your wardrobe, or splurging on tech gadgets, KingClub ensures you save on what you love. It’s like getting paid to shop!`
    },
    {
      title: 'World of Options',
      description: `KingClub partners with hundreds of top brands and retailers, so you can save money wherever you shop. From popular online marketplaces to local boutiques, we’ve got you covered.`
    },
    {
      title: 'Easy To Use',
      description: `Saving money has never been easier. With KingClub, there are no complicated steps or hidden fees. Just link your card or shop through the KingClub app, and we’ll take care of the rest.`
    },
    {
      title: 'Exclusive Deals',
      description: `As a KingClub member, you’ll enjoy access to exclusive deals and perks that non-members can only dream of.`
    },
  ];

  howKingClubWorksItems = [
    {
      step: '1',
      title: 'Shop',
      icon: this.kingAseets.Shop,
      description: 'Unlock Discount On Every Eligible Purchase'
    },
    {
      step: '2',
      title: 'Save',
      icon: this.kingAseets.EarnDiscount,
      description: 'Earn discounts on every eligible purchase.'
    },
    {
      step: '3',
      title: 'Redeem',
      icon: this.kingAseets.Redeem,
      description: 'Withdraw dsd fdsfsdf ewrwer rewfdsf srwerwe fs dfsdfsd werwerwefsdfsdf  adsfsdf  your earnings anytime, hassle-free. It’s quick, easy, and rewarding!'
    },
  ]

  testimonials = [
    {
      user:'Olga Ivanov',
      comment:'I’ve earned over $200 in cash back this year – it’s like free money!',
      avatar: this.kingAseets.Avatar1,
    },
    {
      user:'Alex Flores',
      comment:'It’s so easy to use, and the cashback adds up quickly. Highly recommend!',
      avatar: this.kingAseets.Avatar2,
    },
    {
      user:'Sarah brown',
      comment:'KingClub makes shopping so rewarding. I love the exclusive deals.',
      avatar: this.kingAseets.Avatar3,
    },
    {
      user:'Austin Gonzalez',
      comment:'I’ve earned over $200 in cash back this year – it’s like free money!',
      avatar: this.kingAseets.Avatar4,
    },
  ]

  faqItems = [
    {
      question: 'Is KingClub really free?',
      answer: 'Yes, joining KingClub is completely free. Enjoy exclusive savings, rewards, and gift card opportunities with no membership fees.',
      isExpanded: false
    },
    {
      question: 'How long does it take to receive my savings?',
      answer: 'You receive your savings instantly in your main wallet right after completing your purchase.',
      isExpanded: false
    },
    {
      question: 'Is my personal information safe with KingClub?',
      answer: 'We are committed to safeguarding your personal details through secure, encrypted systems that meet global data protection standards`',
      isExpanded: false
    },
    {
      question: 'How do I redeem my savings?',
      answer: "You can use the amount you received in your wallet anytime you like—it's ready whenever you are!",
      isExpanded: false
    },
    {
      question: 'Can I switch back from KingClub to my original account later?',
      answer: `After upgrading to KingClub, switching back to your previous account settings won't be available. But you'll retain all your savings and enjoy ongoing perks — such as enhanced rates and exclusive offers when buying gift cards.`,
      isExpanded: false
    },
  ];

  loyaltyLevels = [
    {
      level: 'Bronze',
      icon: this.kingAseets.BronzeBadge,
      percentage: 3 ,
      top: this.isMobileView ? '4%' : '5%',
      left: this.isMobileView ? '15%' : '26%'
    },
    {
      level: 'Silver',
      icon: this.kingAseets.SilverBadge,
      percentage: 6,
      top: this.isMobileView ? '30%' : '30%',
      left:this.isMobileView ?  '8%' : '15%'
    },
    {
      level: 'Gold',
      icon: this.kingAseets.GoldBadge,
      percentage: 10,
      top: this.isMobileView ? '57%' : '55%',
      left: this.isMobileView ? '1%' : '4%'
    },
    {
      level: 'Diamond',
      icon: this.kingAseets.DiamondBadge,
      percentage: 16,
      top: this.isMobileView ? '83%' : '80%',
      left: this.isMobileView ? '-7%' : '-7%'
    },
  ]

  col1 = [];
  col2 = [];

  expandedFaqIndex = -1;
  hoveredLevelIndex = -1;
  membersCount = 500;
  membersDuration = 2000;
  
  constructor(
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    let items = Math.ceil(this.faqItems.length / 2); 
    this.col1 = [...this.faqItems.slice(0 , items)]
    this.col2 = [...this.faqItems.slice(items)]
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.screenWidth = (event.target as Window).innerWidth;
    this.isMobileView = this.screenWidth <= 960;
    this.loyaltyLevels = [
      {
        level: 'Bronze',
        icon: this.kingAseets.BronzeBadge,
        percentage: 3 ,
        top: this.isMobileView ? '4%' : '5%',
        left: this.isMobileView ? '15%' : '26%'
      },
      {
        level: 'Silver',
        icon: this.kingAseets.SilverBadge,
        percentage: 6,
        top: this.isMobileView ? '30%' : '30%',
        left:this.isMobileView ?  '8%' : '15%'
      },
      {
        level: 'Gold',
        icon: this.kingAseets.GoldBadge,
        percentage: 10,
        top: this.isMobileView ? '57%' : '55%',
        left: this.isMobileView ? '1%' : '4%'
      },
      {
        level: 'Diamond',
        icon: this.kingAseets.DiamondBadge,
        percentage: 16,
        top: this.isMobileView ? '83%' : '80%',
        left: this.isMobileView ? '-7%' : '-7%'
      },
    ]    
  }

  toggleFaq(event: Event, index : number){
    event.preventDefault();
    if (this.expandedFaqIndex === index) {
      this.expandedFaqIndex = -1;
    } else {
      this.expandedFaqIndex = index;
    }
  }

  joinKingClubBtnClicked(){
    this.dialog.open(AccountSwitchDialogComponent,
    { 
      maxWidth: '600px',
      minHeight: '280px',
      panelClass: 'switch-account-dialog',
    })
  }


}
